import {IntermediatePart} from "../../intermediatePart";
import DesignNavigationItem from "../../../../visComponents/designNavigationItem";
import {topCabinetModuleSystem} from "./cabinetModuleSystem";
import store from "../../../../../store";

export default class TopCabinet extends IntermediatePart {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'top_cabinet';
    this.partName = 'Top Cabinet';
    this.translateId = "visualizer.kitchen.cabinet.top_cabinet";
    this.canBeDisabled = true;
    this.layerPriority = 1;
    if (isChild) {
      this.moduleSystem = topCabinetModuleSystem;
      this.defaultInlayType = "Wood"; // Cascade or Wood
      this.inlayTypes = [{
        name: "Cascade",
        moduleParts: ["2_4", "2_5", "5_4", "5_5","7_4", "7_5",]
      }]; // array of objects, for ex. {name: "Cascade", moduleParts: ["3_2", "7_56"]}
    }
  }

  load(dbFeature) {
    const parts = dbFeature.metaData && dbFeature.metaData["Parts"];
    const module = dbFeature.metaData && dbFeature.metaData["Module"];
    if (module && module[0] !== "0") {
      return super.load_(dbFeature, new TopCabinet(false, null),true, 'moduleParts');
    } else if (parts) {
      dbFeature.displayName = dbFeature.displayName.replace(/M_0(.*?) /, "M ").replace(/ Part1/, "");
      const partNumber = +dbFeature.metaData["Part"][0];
      return super.load_(dbFeature, new TopCabinet(false, partNumber),
        true, partNumber === 1 ? 'features' : 'featuresParts');
    }
    return super.load_(dbFeature, new TopCabinet());
  }

  navigationSubItems(filters, searchText) {
    const filteredAvailableFeatures = super.getFeaturesBySearchText(super.getFilteredFeaturesByFilters(filters), searchText);
    let featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions(), filteredAvailableFeatures);
    const topCabinetApplianceType = this.getParent().getTopCabinetApplianceType();
    const allowedPorticos = [
      "Portico White Chocolate S Hood Layout 2",
      "Portico White Chocolate L Hood Layout 2",
      "Portico White Chocolate SP Hood Layout 2",
      "Portico White Chocolate S Microwave Layout 2",
      "Portico White Chocolate L Microwave Layout 2",
      "Portico White Chocolate SP Microwave Layout 2"
    ];
    featuresToDisplay = featuresToDisplay
      .filter((feature) => {
        return feature.metaData["Appliance"] && feature.metaData["Appliance"].includes(topCabinetApplianceType)
      })
      .filter((feature) => {
        if (feature.metaData["Module"]) {
          return (feature.metaData["Module"][0] === "0" && feature.metaData["Part"][0] === "1")
        }
        return true
      })
      .filter((feature) => {
        if (feature.partName.includes("Portico White Chocolate") && !allowedPorticos.includes(feature.partName)) {
          return false
        }
        return true
      });

    return featuresToDisplay.map(_ => new DesignNavigationItem(_.featureName, _));
  }

  changeLayout() {
    if (this.disabled) {
      this.disabled = false;
      this.disabledClick();
    }
  }

  disabledClick() {
    this.activeFeatureParts.forEach((activeFeaturePart) => {
      activeFeaturePart.disabled = this.disabled
    });
    const topHandle = this.getParent().topHandle;
    if (topHandle) {
      topHandle.disabled = this.disabled;
    }
    const crownMolding = this.getParent().crownMolding;
    if (crownMolding) {
      crownMolding.disabled = this.disabled;
    }
  }

  async handleClick(ignoreLocked, clickFrom = "") {
    const parent = this.getParent();
    const layout = parent.getParent().layout;
    const backsplash = layout.parts["Walls"] && layout.parts["Walls"].backsplash;
    const backsplashActiveFeature = backsplash ? backsplash.activeFeature : null;

    if (backsplashActiveFeature && backsplash.featureIsFullWall(backsplashActiveFeature) && this.metaData["CabinetLayout"]) {
      const splittedName = backsplashActiveFeature.getCountertopGroupsSplittedFeatureName();
      const conditions = [{
        propName: 'CabinetLayout',
        propValue: this.metaData["CabinetLayout"]
      }];
      if (!backsplashActiveFeature.matchesMetaForArrayOfConditions(conditions)) {
        const matchedByName = backsplash.findFeatureByPartName(splittedName);
        if (!matchedByName || !matchedByName.matchesMetaForArrayOfConditions(conditions)) {
          await backsplash.setFeatureByName(splittedName);
        }
      }
    }

    super.handleClick(ignoreLocked, clickFrom);
    parent.activeFeatureParts = parent.setActiveFeatureParts();

    this.featureClicked();
  }

  availableFeatures(cabinetFeatures) {
    return cabinetFeatures.filter(cabinetFeature => cabinetFeature.partNumber === 1)
  }

  getArrayOfConditions() {
    const cabinetParent = this.getParent();
    return [{
      propName: 'RoomLayout',
      propValue: cabinetParent.layout.getCurrentLayoutAbbreviation()
    // },{
    //   propName: 'Appliance',
    //   propValue: cabinetParent.getTopCabinetApplianceType()
    }];
  }

  setZIndex(zIndexes) {
    if(zIndexes) {
      const zIndex = zIndexes.Cabinet.TopCabinet;
      const zIndex2 = zIndexes.Cabinet.TopCabinet2;
      const zIndexBox = zIndexes.Cabinet.TopCabinetModuleBox;
      const zIndexBox2 = zIndexes.Cabinet.TopCabinetModuleBox2;
      if (this.activeFeature) {
        if (this.activeFeature.metaData["Module"] && this.activeFeature.metaData["Module"][0] === "0") {
          this.activeFeature.layer.zIndex = zIndexBox;
        } else {
          this.activeFeature.layer.zIndex = zIndex;
        }
      }
      if (this.activeFeatureParts && this.activeFeatureParts.length) {
        this.activeFeatureParts.forEach((activeFeaturePart) => {
          if (activeFeaturePart && activeFeaturePart.layer) {
            if (activeFeaturePart.metaData["Module"] && !activeFeaturePart.metaData["Part"]) {
              const module = activeFeaturePart.metaData["Module"][0];
              const modulePart = activeFeaturePart.metaData["ModulePart"][0];
              activeFeaturePart.layer.zIndex = zIndexes.Cabinet.TopCabinetModules[module+"_"+modulePart];
            } else if (this.activeFeature.metaData["Module"] && this.activeFeature.metaData["Module"][0] === "0") {
              activeFeaturePart.layer.zIndex = zIndexBox2;
            } else {
              activeFeaturePart.layer.zIndex = zIndex2;
            }
          }
        });
        // // go again & try to find the same zIndex, cause we might have 3_3 - 2 times...
        // this.activeFeatureParts
        //   .filter(activeFeaturePart => activeFeaturePart && activeFeaturePart.layer)
        //   .forEach((activeFeaturePart) => {
        //     const hasTheSameZIndex = this.activeFeatureParts.some(testFeaturePart => {
        //       return (testFeaturePart.layer.zIndex === activeFeaturePart.layer.zIndex)
        //         && (testFeaturePart.partName !== activeFeaturePart.partName)
        //     });
        //     if (hasTheSameZIndex) {
        //       activeFeaturePart.layer.zIndex++;
        //     }
        //   })
      }
    }
  }

  matchesInlayType(feature, module = "1", modulePart = "1") {

    const featureFilterValueIDs = feature.dbFeature.filterValueIDs;
    if (!featureFilterValueIDs) {
      return true
    }

    const filterGroups = store.getState().filterState.filterGroups;
    const filterGroup = filterGroups.find(group => group.name === "Inlay Type");
    if (!filterGroup) {
      return true
    }

    const modulePartJoined = module + "_" + modulePart;

    if (this.inlayTypes.length) {
      for (let i = 0; i <= this.inlayTypes.length - 1; i++) {
        const inlayTypeObject = this.inlayTypes[i];
        const fValue = filterGroup.values.find(val => {
          return (inlayTypeObject.moduleParts.includes(modulePartJoined))
            ? val.value === inlayTypeObject.name
            : val.value === this.defaultInlayType
        });
        // console.log("fValue", fValue);
        // console.log("featureFilterValueIDs[filterGroup.id]", featureFilterValueIDs[filterGroup.id]);
        return fValue && featureFilterValueIDs[filterGroup.id] && featureFilterValueIDs[filterGroup.id].includes(fValue.id)
      }
    } else {
      const fValue = filterGroup.values.find(val => val.value === this.defaultInlayType);
      return fValue && featureFilterValueIDs[filterGroup.id] && featureFilterValueIDs[filterGroup.id].includes(fValue.id)
    }
  }

  setLayers(layout) {
    if (this.activeFeature && (this.activeFeature.matchesMetaForArrayOfConditions(this.getArrayOfConditions()))) {
      this.checkIfFeaturePartIsMatching();
      super.setLayers(layout);
    } else {
      this.setDefault();
      super.setLayers(layout);
    }
  }

  getActiveFeatureConditions(fromFeature = this.activeFeature) {
    const arrayOfConditions = this.getArrayOfConditions();
    const applianceType = fromFeature.metaData["Appliance"] ? fromFeature.metaData["Appliance"][0] : null;
    const cabinetLayout = fromFeature.metaData["CabinetLayout"] ? fromFeature.metaData["CabinetLayout"][0] : null;
    const doorSet = fromFeature.metaData["DoorSet"] ? fromFeature.metaData["DoorSet"][0] : null;
    if (applianceType) {
      arrayOfConditions.push({
        propName: 'Appliance',
        propValue: applianceType
      })
    }
    if (cabinetLayout) {
      arrayOfConditions.push({
        propName: 'CabinetLayout',
        propValue: cabinetLayout
      })
    }
    if (doorSet) {
      arrayOfConditions.push({
        propName: 'DoorSet',
        propValue: doorSet
      })
    }
    return arrayOfConditions
  }

  setActiveFeatureParts(fromFeature = this.activeFeature, activeFeatureConditions = []) {
    let activeFeatureParts = this.getActiveFeaturePartsAccordingToActiveFeature(fromFeature, activeFeatureConditions);
    if (fromFeature && fromFeature.metaData["Module"]) {
      activeFeatureParts = [...activeFeatureParts, ...this.findFeaturesByModuleSystem(fromFeature)];
      if (fromFeature.metaData["Appliance"] && fromFeature.metaData["Appliance"].includes("Hood")) {
        activeFeatureParts = activeFeatureParts.filter(fPart => fPart.metaData["Module"]
          && !fPart.metaData["Module"].includes("6"))
      }
      activeFeatureParts.forEach((activeFeaturePart) => {
        activeFeaturePart.disabled = this.disabled
      });
    }
    return activeFeatureParts
  }

  findFeaturesByModuleSystem(fromFeature = this.activeFeature) {
    let activeFeatureParts = [];
    const featureName = fromFeature.getModuleFeatureName();
    const availableFeatures = this.moduleParts.filter((currentFeature) => {
      // 1) filter by module names, e.g. "Hudson Linen White"
      return featureName === currentFeature.getModuleFeatureName();
    });
    for (let i = 1; i <= this.moduleSystem.length; i++ ) {
      const currentModuleSystemNumber = i - 1;
      for (let k = 0; k <= this.moduleSystem[currentModuleSystemNumber].length - 1; k++ ) {
        const modulePart = this.moduleSystem[currentModuleSystemNumber][k];
        const modulePartSplitted = modulePart.split("_");
        const moduleMatchingPart = availableFeatures.find((feature) => {
          return +feature.metaData["Module"][0] === i
            && feature.metaData["ModulePartWidth"][0] === modulePartSplitted[0]
            && feature.metaData["ModulePartHeight"][0] === modulePartSplitted[1]
            && feature.metaData["ModulePart"][0] === modulePartSplitted[2]
            && this.matchesInlayType(feature, feature.metaData["Module"][0], modulePartSplitted[2])
        });
        if (moduleMatchingPart) {
          activeFeatureParts.push(moduleMatchingPart);
          // } else { // this is for debugging only - look for features which are not exist
          //   console.log("this.moduleSystem[i]", i);
          //   console.log("modulePartIndex", k);
        }
      }
    }
    return activeFeatureParts
  }

  getFilterGroupObjectByInlayType(inlayTypeName) {
    const filterGroups = store.getState().filterState.filterGroups;
    const filterGroup = filterGroups.find(group => group.name === "Inlay Type");
    return {
      filterGroup,
      fValue: filterGroup && filterGroup.values.find(val => val.value === inlayTypeName)
    };
  }

  findFeatureByModuleAndModulePart(modulePart = "1_1", inlayTypeName = "Wood") {
    const featureName = this.activeFeature.getModuleFeatureName();
    const availableFeatures = this.moduleParts.filter((currentFeature) => {
      // 1) filter by module names, e.g. "Hudson Linen White"
      return featureName === currentFeature.getModuleFeatureName();
    });
    const modulePartSplitted = modulePart.split("_");
    const filterObject = this.getFilterGroupObjectByInlayType(inlayTypeName);

    for (let i = 1; i <= this.moduleSystem.length; i++ ) {
      const currentModuleSystemNumber = i - 1;
      for (let k = 0; k <= this.moduleSystem[currentModuleSystemNumber].length - 1; k++ ) {
        const moduleMatchingPart = availableFeatures.find((feature) => {

          if (!feature.dbFeature.filterValueIDs[filterObject.filterGroup.id]) {
            // console.log("No Inlay Type Filter", feature);
            return false
          }

          return +feature.metaData["Module"][0] === i
            && feature.metaData["ModulePartWidth"][0] === modulePartSplitted[0]
            && feature.metaData["ModulePartHeight"][0] === modulePartSplitted[1]
            && feature.metaData["ModulePart"][0] === modulePartSplitted[2]
            && filterObject.filterGroup && filterObject.fValue &&
            feature.dbFeature.filterValueIDs[filterObject.filterGroup.id].includes(filterObject.fValue.id)
        });
        if (moduleMatchingPart) {
          return moduleMatchingPart
        }
      }
    }
  }

  canUseNavigationFilter() {
    return this.activeFeature && this.activeFeature.metaData["Module"]
      && this.activeFeature.metaData["Module"][0] === "0";
  }
}
